module.exports = __webpack_public_path__ + "static/media/18ECA4.46d3df63.jpg";